
import PokerTableMySeatPokers from "../../../table/module/poker_table/poker_myseat_pokers";
import TransformHolder from "./transformHolder";
import PromiseUtility from "../../../../utility/promiseUtility";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import Utility from "../../../../utility/utility";
import { Card } from "./bipai_card_common";
const { ccclass, property, menu } = cc._decorator;


@ccclass
@menu("custom/bipai/bipai_myseat_cards")
export default class BiPaiMySeatCards extends PokerTableMySeatPokers{
    @property([TransformHolder])
    transformHolderList: TransformHolder[] = []

    @property(TransformHolder)
    moPaiTransformHodler: TransformHolder = null

    @property(TransformHolder)
    fromTransformHolder: TransformHolder = null

    @property(cc.Node)
    nodeResultTag: cc.Node = null

    @property(cc.Node)
    nodeResultWin: cc.Node = null

    @property(cc.Node)
    nodeResultLose: cc.Node = null

    @property(cc.Label)
    labelLoseResult: cc.Label = null

    @property(cc.Label)
    labelWinResult: cc.Label = null

    showResult(show: boolean, num?: number, isGray?: boolean){
        this.nodeResultTag.active = !!show
        this.labelWinResult.string = num + ''
        this.labelLoseResult.string = num + ''
        this.nodeResultWin.active = show && !isGray
        this.nodeResultLose.active = show && !!isGray
    }

    playFaPaiAnim(codeList: number[], pointNum: number, duration: number, interval: number, delay: number, onFinish?: Function, onStart?: Function, easeType?){
        let self = this
        // this.showPokers(true, codeList)
        // let pokers = this.pokers
        // let fromTranData = this.fromTransformHolder.transformDataList[0]
        // self.showResult(false)
        // for (let index = 0; index < pokers.length; index++) {
        //     const poker = pokers[index];
        //     let node = poker.node
        //     node.position = node.parent.convertToNodeSpaceAR(fromTranData.worldPos)
        //     let holder = this.transformHolderList[index]
        //     let dataList = holder.transformDataList
        //     let tmpTranData = dataList[index]
        //     node.angle = fromTranData.angle
        //     node.scale = fromTranData.scale
        //     node.active = false
        //     self.scheduleOnce(function(){
        //         node.active = true     
        //         let targetLocalPos = node.parent.convertToNodeSpaceAR(tmpTranData.worldPos)           
        //         self.playNodeAnim(node, targetLocalPos, tmpTranData.scale, tmpTranData.angle, duration, null,  function(){
        //             index == pokers.length - 1 && onFinish && onFinish()
        //         })
        //         if(index == pokers.length - 1){
        //             self.scheduleOnce(function(){
        //                 self.showResult(true, pointNum)
        //             }, duration * 0.8)
        //         }
        //     }, delay + interval * index)
        // }

        super.showPokers(false)
        let tmpCodeList = codeList.concat()
        let count = tmpCodeList.length
        let list = []
        let do_funs = []
        for (let index = 0; index < count; index++) {
            let tmpIndex = Utility.randomToInt(0, tmpCodeList.length - 1)     
            let code = tmpCodeList.splice(tmpIndex, 1)[0]
            list.push(code)
            self.sortCodeListByIndex(list)
            let tmpList = list.concat()            
            let tmp_fun = function(cb){
                self.playMoPaiAnim(code, tmpList, -1, duration, delay + interval * index, false, function(){                    
                    if(index == count -1){
                        self.showResult(true, pointNum)
                    }
                    cb && cb()                    
                }, function(){
                    onStart && onStart(index)
                }, easeType)
            }
            do_funs.push(tmp_fun)
        }
        PromiseUtility.all(do_funs).then(function(){
            onFinish && onFinish()
        })
    }

    playMoPaiAnim(code: number, codeList: number[], pointNum: number, duration: number, delay: number, refresh: boolean, onFinish?: Function, onStart?: Function, easeType?){
        let self = this        
        let transformDataList = self.moPaiTransformHodler.transformDataList
        let fromTranData = this.fromTransformHolder.transformDataList[0]
        let pokers = self.pokers
        let poker = self.genPoker(code)
        let index = codeList.indexOf(code)
        pokers.splice(index, 0, poker)
        poker.node.position = poker.node.parent.convertToNodeSpaceAR(fromTranData.worldPos)
        poker.node.angle = fromTranData.angle
        poker.node.scale = fromTranData.scale
        poker.node.active = false
        let nodeList = []
        for (let i = 0; i < pokers.length; i++) {
            let data = self.getPosData(i, codeList.length)          
            nodeList.push(pokers[i].node)  
            nodeList[i].zIndex = data.zIndex              
            pokers[i].original_pos = pokers[i].node.parent.convertToNodeSpaceAR(data.worldPos)  
            pokers[i].original_scale = data.scale   
        }
        let tranData = transformDataList[index]
        let targetPos = poker.node.parent.convertToNodeSpaceAR(tranData.worldPos)
        // let duration1 = duration * 0.7
        // self.playNodeAnim(poker.node, targetPos, tranData.scale, tranData.angle, duration1, delay, function(){
        //     self.showResult(pointNum >= 0, pointNum)
        //     self.playAdjustAnim(nodeList, nodeList.length, duration - duration1, null, function(){
        //         refresh && self.showPokers(true, codeList, {pointNum: pointNum})
        //         onFinish && onFinish()
        //     })
        // }, null, onStart)

        let delay1 = duration * 0.4
        self.playNodeAnim(poker.node, targetPos, tranData.scale, tranData.angle, duration, delay, null, easeType, onStart, duration * 0.9)
        self.playAdjustAnim(nodeList, nodeList.length, duration * 0.5, delay + delay1, function(){            
            refresh && self.showPokers(true, codeList, {pointNum: pointNum})
            onFinish && onFinish()
        }, null, [poker.node], function(){
            self.showResult(pointNum >= 0, pointNum)
        })

    }

    showPokers(show: boolean, codeList?: number[], params?: any): cc.Vec2{
        let self = this        
        let pointNum = -1
        if(params && params.pointNum){
            pointNum = params.pointNum
        }
        this.showResult(show && pointNum >= 0, pointNum)
        this.unscheduleAllCallbacks()
        this.removeAllPokers()        
        if(show){
            let pokerList = this.genPokerList(codeList, false)
            let nodeList = []
            for (let index = 0; index < pokerList.length; index++) {
                let poker = pokerList[index]    
                poker.show()
                nodeList.push(poker.node)
                if(params){
                    if(params.hidePoker){
                        poker.hide()
                    }
                }                         
                poker.showFace(true)                
            }
            let targetCount = 0
            if(params && params){
                targetCount = params.targetLayoutCount
            }
            let centerLocalPos = this.formatPokersLayout(pokerList, targetCount)
    
            if(params){
                if(params.playAdjustAnim){
                    self.playAdjustAnim(nodeList, nodeList.length, params.duration, params.delay, function(){
                        self.showPokers(true, codeList)
                        params.onFinishPlayAdjustAnim && params.onFinishPlayAdjustAnim()
                    })
                }
            }

            let worldPos = this.nodePokersParent.convertToWorldSpaceAR(centerLocalPos)
            return worldPos
        }
        return cc.Vec2.ZERO
    }

    playAdjust(duration: number, onFinish?: Function){
        let self = this
        let pokers = self.pokers
        let nodeList = []
        for (let index = 0; index < pokers.length; index++) {
            const element = pokers[index];
            nodeList.push(element.node)
        }
        self.playAdjustAnim(nodeList, nodeList.length, duration, 0, onFinish)
    }

    protected playAdjustAnim(nodeList: cc.Node[], targetCount: number, duration: number, delay?: number, onFinish?: Function, easingType?, ignoreNodeList?: cc.Node[], onStart?: Function){
        let self = this
        if(targetCount == 0){
            onFinish && onFinish()
            return
        }
        let isIgnoreNode = function(node: cc.Node){
            if(ignoreNodeList){
                for (let index = 0; index < ignoreNodeList.length; index++) {
                    const tmp = ignoreNodeList[index];
                    if(tmp == node){
                        return true
                    }
                }
            }
            return false
        }
        let doFuns = []
        for (let index = 0; index < nodeList.length; index++) {
            const node = nodeList[index];
            if(isIgnoreNode(node)){
                continue
            }
            let data = self.getPosData(index, targetCount)
            let targetPos = node.parent.convertToNodeSpaceAR(data.worldPos)
            doFuns.push(function(cb){self.playNodeAnim(node, targetPos, data.scale, data.angle, duration, delay, cb, easingType)})
        }
        let node = self.nodeResultTag
        let tranData = self.getPosData(targetCount, targetCount)
        let targetPos = node.parent.convertToNodeSpaceAR(tranData.worldPos)  
        doFuns.push(function(cb){self.playNodeAnim(node, targetPos, tranData.scale, tranData.angle, duration, delay, cb, easingType, onStart)})
        if(doFuns.length == 0){
            onFinish && onFinish()
            return
        }
        PromiseUtility.race(doFuns).then(function(){
            onFinish && onFinish()
        })
    }

    protected playNodeAnim(node: cc.Node, targetPos: cc.Vec2, targetScale: number, targetAngle: number, duration: number, delay?: number, onFinish?: Function, easingType?, onStart?: Function, rotDuration?: number){
        let self = this          
        let do_fun = function(){
            onStart && onStart()
            let moveAnim = cc.moveTo(duration, targetPos)   
            rotDuration = rotDuration || duration    
            let rotaAnim = cc.rotateTo(rotDuration, targetAngle)
            let scaleAnim = cc.scaleTo(duration, targetScale)
            if(easingType){
                moveAnim = moveAnim.easing(easingType)
                rotaAnim = rotaAnim.easing(easingType)
                scaleAnim = scaleAnim.easing(easingType)
            }

            let tmpFun = function(){
                self.setNodeActionCallback(node, null)
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)    
            self.checkAndDealCallback(node)   
            node.active = true     
            self.setNodeActionCallback(node, tmpFun)
            let swap = cc.spawn([moveAnim, rotaAnim, scaleAnim])
            var seq = cc.sequence([swap, callFun])            
            node.active = true
            node.stopAllActions()
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    protected playFadeAnim(node: cc.Node, from: number, to: number, duration: number, delay?: number, onFinish?: Function){
        let self = this
        let do_fun = function(){
            node.opacity = from
            let fadeAnim = cc.fadeTo(duration, to)
            let tmpFun = function(){
                self.setNodeActionCallback(node, null)
                onFinish && onFinish()
            }.bind(self)
            let callFun = cc.callFunc(tmpFun)
            self.checkAndDealCallback(node)  
            node.active = true
            self.setNodeActionCallback(node, tmpFun)
            var seq = cc.sequence([fadeAnim, callFun])
            node.runAction(seq)
        }
        if(delay && delay > 0){
            self.scheduleOnce(function(){
                do_fun()
            }, delay)
        }else{
            do_fun()
        }
    }

    protected formatPokersLayout(pokerList: PokerTablePokerBase[], targetCount?: number): cc.Vec2{
        if(!pokerList || pokerList.length == 0){
            return cc.Vec2.ZERO
        }
        targetCount = targetCount || pokerList.length                
        for (let i = 0; i < pokerList.length; i++) {
            let poker = pokerList[i];          
            let data = this.getPosData(i, targetCount)
            let localPos = poker.node.parent.convertToNodeSpaceAR(data.worldPos)
            poker.node.position = localPos
            poker.original_pos = localPos
            poker.node.zIndex = data.zIndex
            poker.node.angle = data.angle 
            poker.original_angle = data.angle
            poker.node.scale = data.scale || 1
            poker.original_scale = poker.node.scale
        }
        let tranData = this.getPosData(pokerList.length, targetCount)
        this.nodeResultTag.position = this.nodeResultTag.parent.convertToNodeSpaceAR(tranData.worldPos)   
        return cc.Vec2.ZERO
    }

    protected sortCodeListByIndex(codeList: number[]){
        codeList.sort(function(a, b){
            let aIndex = Card.codeToIndex(a)
            let bIndex = Card.codeToIndex(b)
            if(aIndex == bIndex){
                let aColor = Card.codeToColor(a)
                let bColor = Card.codeToColor(b)
                return aColor - bColor
            }
            return aIndex - bIndex
        })
    }

    protected getPosData(index: number, count: number){
        let hold = this.transformHolderList[count - 1]
        let data = hold.transformDataList[index]  

        return data
    }

    protected on_drag(poker: PokerTablePokerBase){
        this.mFirstHoverPoker = poker
        this.mLastHoverPoker = poker
        this.on_draging_pokers()
    }

    protected on_press(poker: PokerTablePokerBase){
        this.mFirstHoverPoker = poker
        this.mLastHoverPoker = poker
        this.on_draging_pokers()
    }

    protected on_press_up(poker: PokerTablePokerBase){
        if(poker != null){
            if(this.mFirstHoverPoker == null){
                this.mFirstHoverPoker = poker
            }
            if(this.mLastHoverPoker == null){
                this.mLastHoverPoker = poker
            }
        }else{
            
        }
        if(this.mLastHoverPoker != null){
            this.on_draging_pokers()
            this.on_finish_drag_pokers()
        }
    }

    protected on_drag_empty(){
        this.mFirstHoverPoker = null
        this.mLastHoverPoker = null
        this.on_draging_pokers()
    }

    protected check_drag_mark_singel(poker: PokerTablePokerBase, isLeftPokersUnMark: boolean, startPoker: PokerTablePokerBase): 
    {isLeftPokersUnMark: boolean, startPoker: PokerTablePokerBase}{
        if(isLeftPokersUnMark){
            poker.marked = false
        }else{
            if(poker == this.mFirstHoverPoker){
                poker.marked = true
                if(startPoker != null || poker == this.mLastHoverPoker){
                    isLeftPokersUnMark = true
                }else{
                    startPoker = poker
                }
            }else if(poker == this.mLastHoverPoker){
                poker.marked = true
                if(startPoker != null || poker == this.mFirstHoverPoker){
                    isLeftPokersUnMark = true
                }else{
                    startPoker = poker
                }
            }else{
                if(startPoker != null){
                    poker.marked = true
                }else{
                    poker.marked = false
                }
            }
        }
        return {isLeftPokersUnMark: isLeftPokersUnMark, startPoker: startPoker}
    }

    protected refreshPokersMarkState(){
        
    }

    protected checkAndDealCallback(node: cc.Node){
        let self = this
        let lastFun = self.getNodeActionCallback(node)            
        if(lastFun){
            lastFun()
            return self.checkAndDealCallback(node)
        }  
    }

    protected setNodeActionCallback(node: cc.Node, callback: Function){
        node['_action_callback'] = callback
    }    

    protected getNodeActionCallback(node: cc.Node){
        return node['_action_callback']
    }
}
